import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Banner() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const onChange = (index) => {
    setCurrentSlide(index);
  };

  const onClickItem = (index) => {
    console.log(`Clicked item ${index}`);
  };

  // const onClickThumb = (index) => {
  //     console.log(`Clicked thumbnail ${index}`);
  // };
  return (
    <Carousel
      showArrows={true}
      selectedItem={currentSlide}
      onChange={onChange}
      onClickItem={onClickItem}
      showThumbs={false} // Hide thumbnails
      autoPlay={true}
      interval={3000}
      infiniteLoop={true}
      stopOnHover={true}
    >
      <div>
        <img src="./BannerImg1.jpg" alt="slide1" />

      </div>
      <div>
        <img src="./BannerImg2.jpg" alt="slide2" />

      </div>
      <div>
        <img src="./BannerImg3.jpg" alt="slide3" />

      </div>
      <div>
        <img src="./BannerImg4.jpg" alt="slide4" />

      </div>
      <div>
        <img src="./BannerImg5.jpg" alt="slide5" />

      </div>
      <div>
        <img src="./BannerImg6.jpg" alt="slide6" />

      </div>
    </Carousel>
  );
}

export default Banner;
